import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { FinanceAwardsPageService } from '../finance-awards.page.service';
import { FinanceAwardsAcceleratorViewPart } from './accelerator/finance-awards-accelerator-view.part';
import { FinanceAwardsEntrepreneurViewPart } from './entrepreneur/finance-awards-entrepreneur-view.part';
import { FinanceAwardsTrimesterViewPart } from './trimester/finance-awards-trimester-view.part';


@Component({
	selector: 'finance-awards-views-part',
	standalone: true,
	imports: [
		FinanceAwardsEntrepreneurViewPart,
		FinanceAwardsAcceleratorViewPart,
		FinanceAwardsTrimesterViewPart,
		DroplistWidget,
		NgSwitch,
		NgSwitchCase
	],
	templateUrl: './finance-awards-views.part.html',
})
export class FinanceAwardsViewsPart implements OnInit {

	public service = inject(FinanceAwardsPageService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}